import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { GTMEventLogger } from 'utils/analytics';

import { MenuConfigWithModule } from 'types/route';

import { GTMEvents } from 'constants/enums';

import styles from './InlineMenu.module.scss';

interface InlineMenuProps {
  menuItems: MenuConfigWithModule[];
  onItemClick: () => void;
}

const InlineMenu: FC<InlineMenuProps> = ({ menuItems, onItemClick }) => {
  const { t } = useTranslation();

  const handleClick = (event?: GTMEvents) => {
    if (event) {
      GTMEventLogger(event);
    }

    onItemClick();
  };

  return (
    <div className={styles.inlineMenu}>
      {menuItems.map((item) => (
        <Link
          to={item.path || '/'}
          key={item.key}
          className={styles.menuItem}
          onClick={() => handleClick(item.event)}
        >
          {item.icon}
          {t(item.label)}
        </Link>
      ))}
    </div>
  );
};

export default InlineMenu;
